var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"loading"},[_c('van-loading',{attrs:{"color":"#B71C1C"}}),_vm._v(" "),_c('span',[_vm._v("正在加载首页")])],1):(_vm.hasBossDashboard)?_c('boss-home',{attrs:{"session":_vm.session}}):_c('employee-home')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1672c1b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/HomeEntry.vue
// module id = null
// module chunks = 